// Formatting utilities for consistent display across the application

// Compact formatters - single source of truth
export const fmtIcp = (x) => `${x.toFixed(2)} ICP`;
export const fmtUsd = (x) => `$${x.toFixed(2)}`;
export const fmtIcpUsd = (icp, icpUsd) => `${fmtIcp(icp)} · ${fmtUsd(icp * icpUsd)}`;
export const fmtN = (x) => x.toFixed(2);
export const fmtPct = (p) => `${p.toFixed(1)}%`;
export const fmtPctSigned = (p) => `${p >= 0 ? '+' : ''}${p.toFixed(1)}%`;

// Legacy formatters for backward compatibility
export const formatICP = (amount, decimals = 2) => `${amount.toFixed(decimals)} ICP`;
export const formatNICP = (amount, decimals = 2) => `${amount.toFixed(decimals)} nICP`;
export const toUSD = (icpAmount, icpUsdPrice) => icpAmount * icpUsdPrice;
export const formatUSD = (amount, decimals = 2) => `$${amount.toFixed(decimals)}`;
export const formatPercentage = (percentage, decimals = 1) => {
  const sign = percentage >= 0 ? '+' : '';
  return `${sign}${percentage.toFixed(decimals)}%`;
};
export const formatICPWithUSD = (icpAmount, icpUsdPrice) => {
  const usdAmount = toUSD(icpAmount, icpUsdPrice);
  return `${formatICP(icpAmount)} · ${formatUSD(usdAmount)}`;
};

/**
 * Format token amount with proper precision
 * @param {number} amount - Token amount
 * @param {string} symbol - Token symbol
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted token amount
 */
export const formatToken = (amount, symbol, decimals = 2) => {
  return `${amount.toFixed(decimals)} ${symbol}`;
};

/**
 * Format difference amount with sign and styling info
 * @param {number} difference - Difference value
 * @param {string} unit - Unit (ICP, USD, etc.)
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {object} Object with formatted string and styling info
 */
export const formatDifference = (difference, unit = 'ICP', decimals = 2) => {
  const isPositive = difference >= 0;
  const sign = isPositive ? '+' : '';
  const absValue = Math.abs(difference);
  
  return {
    formatted: `${sign}${absValue.toFixed(decimals)} ${unit}`,
    isPositive,
    className: isPositive ? 'positive' : 'negative'
  };
};

/**
 * Check if difference is nearly equal (within threshold)
 * @param {number} percentage - Percentage difference
 * @param {number} threshold - Threshold for "nearly equal" (default: 1)
 * @returns {boolean} True if nearly equal
 */
export const isNearlyEqual = (percentage, threshold = 1) => {
  return Math.abs(percentage) < threshold;
};
